import React, { Component } from "react";
import { connect } from "react-redux";
import config from "./../../common/config";

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let self = this;
    const { isHide } = self.props;
    const sClassName = isHide ? "si-hide" : "";
    return (
      <div className={"si-loader__wrap " + sClassName}>
        <div className="si-loader"></div>
      </div>
    );
  }
}
export default Loader;
